import React from "react";

const Tag = ({ tag }) => {
  return <button className="tag-button">{tag}</button>;
};

export default Tag;
